"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// @ts-ignore
const react_ios_switch_1 = __importDefault(require("react-ios-switch"));
const SwitchSimple = (props) => {
    const { value, onValueChange } = props;
    return (
    // <Switch
    //     // @ts-ignore
    //     activeThumbColor={"#FEFEFE"}
    //     thumbColor={"#FEFEFE"}
    //     trackColor={{ false: "#DDDDDD", true: "#65C466" }}
    //     value={value}
    //     onValueChange={onValueChange}
    // />
    react_1.default.createElement(react_ios_switch_1.default, { checked: value, onChange: onValueChange, onColor: "#65C466", offColor: "#DDDDDD" }));
};
exports.default = SwitchSimple;
